import { BirthScene } from './BirthScene'
import '../birth-intro.css'
import { plainText } from '../plain-text'
import type { RestartMemory } from '../animation/restartRenderer'
import { createPortal } from 'react-dom'
import { useBirthIntro } from '../hooks/useBirthIntro'

type BirthIntroProps = {
  restartMemories: RestartMemory[] | null
  token: number | null
  reduceMotion: boolean
  soundEnabled: boolean
  onComplete: () => void
}

export function BirthIntro({ token, restartMemories, reduceMotion, soundEnabled, onComplete }: BirthIntroProps) {
  const systemReduced = typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false
  const effectiveReduceMotion = reduceMotion || systemReduced
  const { containerRef, canvasRef, finish } = useBirthIntro({ token, restartMemories, reduceMotion: effectiveReduceMotion, soundEnabled, onComplete })
  if (token === null) return null

  return createPortal(
    <div ref={containerRef} onClick={(event) => { if (!(event.target instanceof HTMLButtonElement)) finish() }} className={`birth-intro${effectiveReduceMotion ? ' birth-intro-reduced' : ''}`} data-birth-phase={restartMemories !== null ? 'restart' : effectiveReduceMotion ? 'reduced' : 'heartbeat'} data-birth-elapsed-ms="0" data-birth-skip-ready="false" data-restart={restartMemories !== null ? "true" : "false"} role="dialog" aria-modal="true" aria-label="新人生出生动画" aria-describedby="birth-intro-description" tabIndex={-1}>
      <div className="sr-only" aria-label="上一世回忆">{restartMemories?.map((memory, index) => <p key={index}>{plainText(memory.title)}：{plainText(memory.choice)}</p>)}</div>
      <canvas ref={canvasRef} className="birth-intro-canvas" aria-hidden="true" />
      <BirthScene />
      <span id="birth-intro-description" className="sr-only">{restartMemories !== null ? '上一世回忆结束后，依次播放心跳、婴儿、画框砸落、冲击波和落地庆祝效果。可随时跳过。' : '约 8.7 秒，依次播放心跳、婴儿、画框砸落、冲击波和落地庆祝效果，然后进入人生。可随时跳过。'}</span>
      <button type="button" className="birth-intro-skip" aria-label="跳过开场动画" autoFocus onClick={finish}>轻触屏幕跳过 ▸</button>
    </div>, document.body
  )
}
